import useLocalStorage from './useLocalStorage'

export default function useThemeMode() {
  const userDefaultTheme = window.matchMedia('(prefers-color-scheme: dark)')

  return useLocalStorage<'light' | 'dark'>(
    'pixydocs-theme-mode',
    userDefaultTheme.matches ? 'dark' : 'light',
    false,
  )
}
